export const CONSOLIDATED_SUPPLY_TEXTS = {
  search: 'Buscar material, pedido o destino',
  clearFilter: 'Limpiar filtro',
  editHint:
    'Materiales muestra los totales por depósito. En Cantidades por pedido podés ajustar ' +
    'cada origen o indicar 0 para omitirlo. El precio se informa al emitir.',
  action: 'Generar orden a proveedor',
  title: 'Preparar compra desde pedidos',
  selected: (count) => `${count} ${count === 1 ? 'pedido seleccionado' : 'pedidos seleccionados'}`,
  clear: 'Limpiar selección',
  select: 'Seleccionar pedido para compra',
  selectPage: 'Seleccionar pedidos con faltantes comprables de esta página',
  noEligibleOrders: 'No hay pedidos con faltantes comprables en esta página',
  ineligible: 'El pedido no tiene faltantes comprables',
  provider: 'Proveedor',
  providerError: 'No se pudo consultar el listado de proveedores',
  providerSearch: 'Buscar proveedor',
  commitment: 'Compromiso de entrega',
  materials: 'Materiales',
  origins: 'Cantidades por pedido',
  purchase: 'Datos de compra',
  sections: 'Preparar compra',
  excluded: 'Pedidos excluidos',
  excludedCount: (count) => `Pedidos excluidos (${count})`,
  selectedOrders: 'Seleccionados',
  includedOrders: 'Con materiales para comprar',
  excludedOrders: 'Sin materiales para comprar',
  excludedHint:
    'Son pedidos seleccionados que dejaron de poder incluirse al consultar los saldos y estados '
    + 'actuales. Por ejemplo, sus faltantes ya están incluidos en otra compra o traslado. '
    + 'Revisá el motivo de cada uno; podés continuar con los demás.',
  excludedEmpty: 'No hay pedidos excluidos',
  reason: 'Motivo',
  searchExcluded: 'Buscar pedido o motivo',
  noMatches: 'No hay resultados para esta búsqueda',
  searchDocuments: 'Buscar depósito',
  documentHint:
    'Se crea un borrador por depósito receptor, con el proveedor y el compromiso elegidos. ' +
    'Los pedidos conservan su proyecto o uso interno en cada renglón.',
  lines: 'Renglones',
  pendingProvider: 'Sin seleccionar',
  providerRequired: 'Seleccioná un proveedor en Datos de compra.',
  nothingToBuy:
    'No hay cantidades para comprar. Revisá Cantidades por pedido o actualizá los saldos.',
  invalidQuantities: 'Revisá las cantidades en Cantidades por pedido antes de guardar.',
  retryRequired: 'Actualizá la preparación antes de volver a guardar.',
  editPurchase: 'Editar datos de compra',
  noCommitment: 'Sin compromiso informado',
  quantityError: 'Indicá una cantidad entre 0 y el pendiente de compra.',
  loading: 'Consultando materiales pendientes…',
  next: 'Revisar materiales',
  review: 'Revisar resumen',
  adjust: 'Ajustar por pedido',
  summary: 'Resumen',
  article: 'Material',
  unit: 'Unidad',
  quantity: 'A comprar',
  available: 'Pendiente de compra',
  order: 'Pedido',
  orders: 'Pedidos',
  orderDestination: 'Pedido y destino',
  destination: 'Proyecto',
  warehouse: 'Depósito receptor',
  group: 'Finalidad',
  cancel: 'Cancelar',
  close: 'Cerrar',
  save: 'Crear borrador',
  saveMultiple: 'Crear borradores',
  retry: 'Actualizar saldos',
  empty: 'No hay materiales pendientes de compra',
  error: 'No se pudo preparar la compra',
  documents: (count) => `${count} ${count === 1 ? 'borrador a crear' : 'borradores a crear'}`,
  success: (count) => `${count} ${count === 1 ? 'borrador creado' : 'borradores creados'}`,
  view: 'Ver órdenes',
  refreshHint:
    'Si cambia un saldo, actualizá la propuesta y revisá las cantidades antes de confirmar.',
};

export const CONSOLIDATED_SUPPLY_SECTIONS = [
  { id: 'purchase', label: CONSOLIDATED_SUPPLY_TEXTS.purchase },
  { id: 'materials', label: CONSOLIDATED_SUPPLY_TEXTS.materials },
  { id: 'origins', label: CONSOLIDATED_SUPPLY_TEXTS.origins },
  { id: 'excluded', label: CONSOLIDATED_SUPPLY_TEXTS.excluded },
  { id: 'summary', label: CONSOLIDATED_SUPPLY_TEXTS.summary },
];
